import { render, staticRenderFns } from "./qyjjjfpjxx.vue?vue&type=template&id=566e4d98&scoped=true&"
import script from "./qyjjjfpjxx.vue?vue&type=script&lang=js&"
export * from "./qyjjjfpjxx.vue?vue&type=script&lang=js&"
import style0 from "./qyjjjfpjxx.vue?vue&type=style&index=0&id=566e4d98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566e4d98",
  null
  
)

export default component.exports